import { useCallback, useState } from "react";
import PDFViewer from "components/PDFViewer";
import PDFContext, { DEFAULT_PDF_CONTEXT, IPDF } from "contexts/PDFContext";
import { readFloat, writeFloat } from "utils/localStorageFloat";

// Podgląd PDF do lewego panelu <SplitSlide/>. Trzyma własny PDFContext, żeby
// zoom/adnotacje nie przeciekały do globalnego kontekstu widoku pod slajdem.

interface Props {
  file: Blob;
  title?: string;
  /** Klucz localStorage z zapamiętanym zoomem. */
  zoomStorageKey: string;
  // (magistrat: bez externalSigning/onSignatureFieldChange/scrollToPage - tutejszy PDFViewer
  // nie ma tych propsow; podpisy pism obsluguje signPositioningMode poza slajdami.)
}

const PdfPreviewPane = ({
  file,
  title,
  zoomStorageKey,
}: Props) => {
  const [pdf, setPdf] = useState<IPDF>(() => ({
    ...DEFAULT_PDF_CONTEXT,
    zoom: readFloat(zoomStorageKey, DEFAULT_PDF_CONTEXT.zoom, 0.1, 8),
  }));

  const setPdfAndSave = useCallback(
    (newPdf: IPDF) => {
      setPdf(newPdf);
      writeFloat(zoomStorageKey, newPdf.zoom);
    },
    [zoomStorageKey],
  );

  return (
    <PDFContext.Provider value={{ PDF: pdf, setPDF: setPdfAndSave }}>
      <PDFViewer
        file={file}
        title={title}
        showCloseButton={false}
        showSignButton={false}
      />
    </PDFContext.Provider>
  );
};

export default PdfPreviewPane;
